export default "__VITE_ASSET__DhAK6Ze8__"